import { Injectable } from '@angular/core';

import { DataEntry, SpaceEntry } from '@osos/shared/api';
import { SpaceEntryPresenterModel } from '@osos/shared/types';
import { FactoryBase } from '../../bases/factory/factory-base';
import { SpaceEntryParserV1Service } from '../../parsers/index';
import { ParserFactory } from '../../services';

@Injectable()
export class SpaceEntryFactoryService extends FactoryBase<
  DataEntry,
  SpaceEntryPresenterModel
> {
  constructor(
    parserFactory: ParserFactory,
    parser_v1: SpaceEntryParserV1Service,
  ) {
    super(parserFactory);
    // register the related parsers within the parser factory:
    parserFactory.register(parser_v1);
  }

  createDataModel(presenter: SpaceEntryPresenterModel): SpaceEntry {
    const parser = this.getParser(
      SpaceEntry,
      SpaceEntryPresenterModel,
      presenter.specificationVersion,
    );
    const result = parser.getDataModel(presenter);

    return result;
  }

  createPresenterModel(model: SpaceEntry): SpaceEntryPresenterModel {
    const parser = this.getParser(
      SpaceEntry,
      SpaceEntryPresenterModel,
      model.specificationVersion,
    );
    const result = parser.getPresenterModel(model);
    return result;
  }
}
